import { createSlice } from '@reduxjs/toolkit';

interface DataState {
  emptyTrashInitiatedTime: string;
}

const initialState: DataState = {
  emptyTrashInitiatedTime: ''
};

export const deletedProjectsState = createSlice({
  name: 'deletedProjectsState',
  initialState,
  reducers: {
    setEmptyTrashInitiatedTime: (
      state,
      { payload: emptyTrashInitiatedTime }
    ) => ({
      emptyTrashInitiatedTime
    })
  }
});

export const { setEmptyTrashInitiatedTime } = deletedProjectsState.actions;

export default deletedProjectsState.reducer;
